import type { IconProps } from './types';

export const ArrowRight = ({ size, ...props }: IconProps) => (
  <svg fill="none" width={size} height={size} viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m12.678.93 6.364 6.363a1 1 0 0 1 0 1.414l-6.364 6.364a1 1 0 0 1-1.414-1.414L15.92 9H1.668a1 1 0 1 1 0-2H15.92l-4.656-4.657A1 1 0 1 1 12.678.93Z"
      clipRule="evenodd"
    />
  </svg>
);
